// Login (Email) already exists when trying to create an institution.
export const LOGIN_ALREADY_EXISTS = 1529675222;

export const LISTS_LIMITATION_EXCEEDED = 1670427460;
